module.exports = __webpack_public_path__ + "img/3.ddcad585.jpg";